import { toast } from "sonner";

/** A app está a correr instalada (ecrã principal), e não dentro do browser? */
export function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches
    || window.navigator.standalone === true;
}

export function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

/**
 * Regista o service worker e avisa quando há versão nova.
 *
 * A versão nova fica em espera até o utilizador aceitar: trocar os ficheiros a
 * meio de uma sessão parte a app. Sem este aviso, a equipa fica presa a uma
 * versão antiga sem perceber porquê.
 */
export function registerServiceWorker() {
  const allowed = process.env.NODE_ENV === "production" || process.env.REACT_APP_ENABLE_SW === "1";
  if (!allowed || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js");

      let reloading = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (reloading) return;
        reloading = true;
        window.location.reload();
      });

      const promptUpdate = (worker) => {
        toast("Nova versão do CRM disponível", {
          description: "Atualiza para ficares com as últimas alterações.",
          duration: Infinity,
          action: { label: "Atualizar", onClick: () => worker.postMessage("SKIP_WAITING") },
        });
      };

      if (registration.waiting) promptUpdate(registration.waiting);

      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        if (!worker) return;
        worker.addEventListener("statechange", () => {
          // `controller` existente = já havia uma versão a correr, logo isto é uma atualização
          if (worker.state === "installed" && navigator.serviceWorker.controller) promptUpdate(worker);
        });
      });

      // Procura versões novas quando se volta à app
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") registration.update().catch(() => undefined);
      });
    } catch {
      // Sem service worker a app continua a funcionar normalmente.
    }
  });
}
